"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ARTICLES_SECTION_SKELETON = void 0;
const ARTICLES_SECTION_SKELETON = exports.ARTICLES_SECTION_SKELETON = 'articles-section-skeleton';
